const complementaryProducts = document.querySelector('.complementary-products-advanced');
const productMainSubmitButton = document.querySelector('.product .buy-buttons button[type="submit"]');

/* NUMBER TO EURO */

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

/* ADD TO CART */

async function addToCart(selectedProducts) {
    const cartDrawer = document.getElementById('cart-drawer');
    
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: selectedProducts.items
        })
    });
  
    if (response.ok) {
        // Rafraîchir le panier (va chercher le HTML à jour)
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Attendre un peu que le refresh se fasse puis ouvrir
        setTimeout(() => {
            cartDrawer?.show();
        }, 200);
    } else {
        console.error('Erreur lors de l\'ajout au panier', await response.json());
    }
}

/* MAIN BUTTON */

function updateMainButtonPrice() {

    const productQuantity = document.querySelector('.product .quantity-selector__input')

    if (productQuantity) {

        // GET PRODUCT PRODUCT PRICE x QUANTITY

        const productQuantityValue = productQuantity.value;
        const productPrice = document.querySelector('#product-price').value;
        const productFinalPriceWithQuantity = productPrice*productQuantityValue;
        let complementaryProductsPrice = 0;

        if (complementaryProducts) {
            
            // GET COMPLEMENTARY PRODUCTS PRICE
            complementaryProductsPrice = document.querySelector('#complementary-products-price').value;
            const productComplementaryProducts = complementaryProducts.querySelectorAll('.products .item');

            productComplementaryProducts.forEach(product => {
                if(product.getAttribute('selected') != null) {
                    const productPrice = product.querySelector('.final-price');
                    if(productPrice.dataset.price){
                        complementaryProductsPrice = parseInt(complementaryProductsPrice) + parseInt(productPrice.dataset.price);
                    }
                }
            });

        }

        // SET NEW FINAL PRICE

        const newProductFinalPrice = parseInt(productFinalPriceWithQuantity) + parseInt(complementaryProductsPrice);

        if (productMainSubmitButton) {
            const buttonFinalPrice = productMainSubmitButton.querySelector('.final-price');
            buttonFinalPrice.innerHTML = numberToEuro(newProductFinalPrice);
        }

    }
  
}
updateMainButtonPrice()

/* BLOCK COMPLEMENTARY PRODUCTS */

if(complementaryProducts){
    
    const complementaryProductsItems = complementaryProducts.querySelectorAll('.item');

    complementaryProductsItems.forEach(item => {

        const productVariantId = item.querySelector('input[name="product-variant-id"]');

        // UPDATE SELECTED VARIANT

        const itemOptions = item.querySelectorAll('.option');

        itemOptions.forEach(option => {

            const optionSelect = option.querySelector('select');

            if (optionSelect) {

                optionSelect.addEventListener('change', () => {
                    productVariantId.value = optionSelect.value;
                })

            }

        })

        // UPDATE SELECT ITEM

        item.addEventListener('click', () => {

            if(item.getAttribute('selected') == null){
                item.setAttribute('selected', '');
            }else{
                item.removeAttribute('selected');
            }

            updateMainButtonPrice();

        })
    })


    // MAIN SUBMIT BUTTON ACTION

    productMainSubmitButton.addEventListener('click', async () => {
        
        const complementaryProductsItems = complementaryProducts.querySelectorAll('.item');

        selectedProducts = {'items':[]}

        complementaryProductsItems.forEach(item => {
            
            if(item.getAttribute('selected') != null){

                const itemProductVariantId = item.querySelector('input[name="product-variant-id"]').value;

                let productInfo = {
                    id: itemProductVariantId,
                    quantity: 1,
                }
        
                selectedProducts['items'].push(productInfo);
                
            }
            
        })

        console.log(selectedProducts);

        setTimeout(() => {
            addToCart(selectedProducts);
        }, 1000);

    })

}